import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import TranslationRowList from './translation-row-list'
import * as API from '../../utility/api'
import {
  addFaqRow,
  setModifiedTranslations,
  updateTranslation
} from '../../actions/admin'
import { loadTranslations } from 'react-redux-i18n'

const withoutExpires = translations => {
  if (!translations || !translations.expires) {
    return translations
  }

  const next = { ...translations }
  delete next.expires
  return next
}

const Translations = ({
  modifiedTranslations,
  translationRowOnChange,
  dispatchAddFaqRow,
  dispatchLoadTranslations,
  ensureTranslations
}) => {
  const [fetching, setFetchinig] = useState(false)
  const translationsForEditor = useMemo(
    () => withoutExpires(modifiedTranslations),
    [modifiedTranslations]
  )

  useEffect(() => {
    if (!modifiedTranslations) {
      ensureTranslations()
    }
  }, [modifiedTranslations, ensureTranslations])

  const saveTranslations = () => {
    if (!translationsForEditor) return

    dispatchLoadTranslations(translationsForEditor)

    setFetchinig(true)
    API.POST('admin/translations', {
      modifiedTranslations: translationsForEditor
    })
      .then(() => setFetchinig(false))
      .catch(() => setFetchinig(false))
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-3">
          <button type="button" onClick={() => saveTranslations()}>
            {fetching ? 'Tallennetaan...' : 'Tallenna muutokset'}
          </button>
        </div>

        <div className="break-md" />

        <TranslationRowList
          translations={translationsForEditor}
          updateTranslation={translationRowOnChange}
          dispatchAddFaqRow={dispatchAddFaqRow}
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  modifiedTranslations: state.admin.modifiedTranslations
})

const mapDispatchToProps = dispatch => ({
  ensureTranslations: () => dispatch(setModifiedTranslations()),
  translationRowOnChange: (lang, topic, key, value, path) =>
    dispatch(updateTranslation(lang, topic, key, value, path)),
  dispatchAddFaqRow: lang => dispatch(addFaqRow(lang)),
  dispatchLoadTranslations: translations =>
    dispatch(loadTranslations(translations))
})

export default connect(mapStateToProps, mapDispatchToProps)(Translations)
